import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React from 'react';

const Layout: React.FC = ({ children }) => (
  <Box sx={{ flexGrow: 1 }}>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </Box>
);
export default Layout;
